import { useQuery } from 'react-query';

import {
  getDinamics,
  getScoreLastMatch,
  getStatics,
} from '@/services/fieldAssistant';

const MINUTO = 60 * 1000;

/**
 * La cache del navegador mantiene los datos por 1 hora.
 * Agrego un cache buster.
 * El archivo con datos dinámicos refresca cada 5 minutos, con cache buster random.
 * El archivo con datos estáticos usa la versión que referencia el archivo de datos
 * dinámicos (refresca sólo si hubo una publicación, cambio de fixture, o algo así).
 * @returns
 */
export const useGetFieldAssistantData = () => {
  const { data: dataDinamics, isLoading: isLoadingDinamics } = useGetDinamics();
  // let faCacheBuster = useAtomValue(userDataAtom_centralSCN2);
  const faCacheBuster = dataDinamics?.versionDelEstatico;
  const { data: dataStatics, isLoading: isLoadingStatics } = useQuery(
    ['getStatics', faCacheBuster],
    async () => await getStatics(faCacheBuster),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!faCacheBuster && !isLoadingDinamics,
    }
  );

  return {
    dataStatics,
    isLoadingStatics,
    dataDinamics,
    isLoadingDinamics,
  };
};

const useGetDinamics = () => {
  const randomValue = (Math.random() + '').substring(3, 15);
  return useQuery('getDinamics', async () => await getDinamics(randomValue), {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    refetchInterval: 5 * MINUTO,
  });
};

export const useGetScoreLastMatch = () => {
  return useQuery('getScoreLastMatch', async () => await getScoreLastMatch(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    enabled: false,
  });
};
